import { forwardRef, type InputHTMLAttributes } from 'react';

const baseClass =
  'min-h-10 w-full rounded-xl border border-[var(--border)] bg-[var(--bg-soft)] px-3 py-2 font-mono text-sm text-[var(--accent)] placeholder:text-[var(--text-muted)] focus:border-[var(--accent)] focus:outline-none focus:ring-0';

export type EmbedInputProps = InputHTMLAttributes<HTMLInputElement>;

/** Поле ввода в стиле прототипа: monospace, accent-текст, focus на accent-border. */
export const EmbedInput = forwardRef<HTMLInputElement, EmbedInputProps>(function EmbedInput(
  { className = '', ...rest },
  ref
) {
  return <input ref={ref} className={`${baseClass} ${className}`} {...rest} />;
});
